<template lang="pug">
  .module__main
    .module-content__container
      .chats__module
        .chats__container
          .chats-list__main
            .chats__title Диалоги: {{ currentChatsAmount }}
            .chats-search__container
              .chats-search-mode__container
                el-switch(
                  v-model="searchModeIsLogin"
                  active-text="Поиск по логину"
                  inactive-text="Поиск по заявке"
                  active-color="#6583ce"
                  inactive-color="#ffae78"
                  )
              .search-input__container
                el-input(v-model="searchQuery" :placeholder="searchInputPlaceholder")
            .chats-legend__container
              .legend__block(@click="handleFilter('opened')")
                .legend-color.opened
                  span(v-if="filters.opened") ✓
                .legend-text Открыт
              .legend__block(@click="handleFilter('unread')")
                .legend-color.unread
                  span(v-if="filters.unread") ✓
                .legend-text Ждет ответа
              .legend__block(@click="handleFilter('closed')")
                .legend-color.closed
                  span(v-if="filters.closed") ✓
                .legend-text Закрыт
              .legend__block(@click="handleFilter('admin')")
                .legend-color.admin
                  span(v-if="filters.admin") ✓
                .legend-text Админ
            .chats-list__block(v-loading="isLoading")
              .chats-dialog__container(
                v-for="chat in currentChats"
                @click="loadChat({ id: chat.id, isOpened: chat.closed === 0 })"
                :class="getChatClassList(chat)"
                )
                .chat-dialog__info
                  .chats-dialog__title Пользователь:
                  .chats-dialog__value {{ chat.username }}
                .chat-dialog__info
                  .chats-dialog__title Последнее:
                  .chats-dialog__value {{ chat.last_message_text }}
                .chat-dialog__info
                  .chats-dialog__title Обновлено:
                  .chats-dialog__value {{ chat.last_message_time }}
                i.el-icon-message.chat-dialog__notification(v-if="chat.unreaded_count > 0")
                .chat-notices__container
                  .chat-claim__notice(v-if="chat.isActiveClaim")
                    el-tooltip(effect="dark" content="Открыта претензия" placement="top-end")
                      i.el-icon-warning
                  .chat-problem__notice(v-if="chat.isProblemOrder")
                    el-tooltip(effect="dark" content="Отмечена проблемной" placement="top-end")
                      i.el-icon-question
                  .chat-lottery__notice(v-if="chat.isLotteryWinner")
                    el-tooltip(effect="dark" content="Победитель последней лотереи" placement="top-end")
                      i.el-icon-medal
          ChatsDialog(
            :showChatLoadingStatus="showChatLoadingStatus"
            :resetMessage="resetMessageTrigger"
            :scrollToEnd="scrollToEndOfDialogTrigger"
            :loadMoreLoading="loadMoreLoading"
            :isOpened="lastActiveChatIsOpened"
            @updateChat="loadChat",
            @resetLastActiveChat="resetLastActiveChat"
            )
          ChatsExchanges(:showChatLoadingStatus="showChatLoadingStatus" @loadChat="loadChat")
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';
  import InfiniteLoading from 'vue-infinite-loading';
  import { CHAT_SEARCH, CHAT_SEARCH_RESET, LOAD_CHAT, LOAD_CHATS_LIST, LOAD_TEMPLATES } from "../../store/const/chats";
  import ChatsDialog from "./Dialog";
  import ChatsExchanges from "./Exchanges";
  export default {
    name: 'ChatsList',
    components: { ChatsExchanges, ChatsDialog, InfiniteLoading },
    data() {
      return {
        per_page: 500,
        changes: {},
        resetMessageTrigger: false,
        scrollToEndOfDialogTrigger: false,
        page: 1,
        updateInterval: null,
        updateTime: 5000, // (ms) период автообновления списка
        isFirstLoading: true,
        showChatLoadingStatus: true,
        lastActiveChatId: null,
        lastActiveChatIsOpened: false,
        searchModeIsLogin: false,
        searchQuery: '',
        loadMoreLoading: false,
        isInfiniteLoading: false,
        isChatLoading: false,
        isChatLoadingActive: false,
        isChatsLoading: false,
        updatePage: false,
        filters: {
          opened: false,
          unread: false,
          closed: false,
          admin: false,
        },
        lastLoadConfig: {
          filters: {},
          searchQuery: '',
        }
      }
    },
    async mounted() {
      await this.loadChatsList();
      await this.loadTemplates();
      this.isFirstLoading = false;
      this.updateInterval = setInterval(() => {
        this.loadChatsList();
        this.loadChat({ id: 'current' });
      }, this.updateTime);
    },
    beforeDestroy() {
      clearInterval(this.updateInterval);
    },
    computed: {
      ...mapGetters('chats', {
        getChats: 'chatsList',
        getActiveChatId: 'activeChatId',
        getSearchResult: 'searchResult',
      }),
      ...mapGetters('settings', {
        exchangeName: 'exchangeName',
      }),
      ...mapGetters([
        'loading',
      ]),
      isLoading() {
        return (this.loading(LOAD_CHATS_LIST) === 'loading' && this.isFirstLoading)
          || this.loading(CHAT_SEARCH) === 'loading';
      },
      searchInputPlaceholder() {
        return this.searchModeIsLogin ? 'Введите логин пользователя' : 'Введите номер заявки';
      },
      currentChats() {
        return Object.values(this.getChats.chats);
      },
      currentChatsAmount() {
        return `${this.getChats.amount}/${this.getChats.total}`;
      },
      isResetList() {
        for (const filter of Object.keys(this.filters)) {
          if (this.filters[filter] !== this.lastLoadConfig.filters[filter]) {
            return true
          }
        }
        return this.searchQuery !== this.lastLoadConfig.searchQuery;
      }
    },
    methods: {
      ...mapActions('chats', {
        loadChats: LOAD_CHATS_LIST,
        loadChatById: LOAD_CHAT,
        loadTemplates: LOAD_TEMPLATES,
        searchChat: CHAT_SEARCH,
        resetChatSearch: CHAT_SEARCH_RESET,
      }),
      async loadChatsList(page = 1) {
        if (this.isChatsLoading) {
          return;
        }
        this.isChatsLoading = true;
        const params = { page, per_page: this.per_page };
        if (this.searchQuery) {
          if (this.searchModeIsLogin) {
            params.username = this.searchQuery;
          } else {
            params.id = this.searchQuery;
          }
        }
        if (this.filters.admin) {
          params.username = 'admin';
        }
        if (this.filters.closed) {
          params.closed = 1;
        }
        if (this.filters.opened) {
          params.opened = 1;
        }
        if (this.filters.unread) {
          params.unread = 1;
        }
        await this.loadChats({ params, resetList: this.isResetList });
        if (page !== 1 || this.updatePage) {
          this.page = page;
        }
        this.updateLastLoadConfig();
        this.isChatsLoading = false;
      },
      updateLastLoadConfig() {
        for (const filter of Object.keys(this.filters)) {
          this.lastLoadConfig.filters[filter] = this.filters[filter];
        }
        this.lastLoadConfig.searchQuery = this.searchQuery;
      },
      resetLastActiveChat() {
        this.lastActiveChatId = null;
      },
      async loadChat({ id, loadMore = false, isOpened }) {
        if (!id) {
          console.log('Null id');
          return;
        }
        if (id === 'current') {
          id = this.lastActiveChatId || this.getActiveChatId;
        }
        let scrollAfterLoad = false;
        if (id !== (this.lastActiveChatId || this.getActiveChatId)) {
          this.resetMessageTrigger = !this.resetMessageTrigger;
          this.showChatLoadingStatus =  true;
          scrollAfterLoad = true;
          this.isChatLoading = false;
          this.lastActiveChatIsOpened = isOpened;
        }
        if (this.isChatLoading) {
          return;
        }
        this.lastActiveChatId = id;
        if (loadMore) {
          this.loadMoreLoading = true;
        }
        this.isChatLoading = true;
        const result = await this.loadChatById({ id, loadMore });
        this.isChatLoading = false;
        if (loadMore) {
          this.loadMoreLoading = false;
        }
        if (scrollAfterLoad) {
          this.scrollToEndOfDialogTrigger = !this.scrollToEndOfDialogTrigger;
        }
        if (result && !result.success && this.isFirstLoading) {
          this.$message({
            type: 'error',
            message: `Ошибка загрузки чата: ${result.message || 'неизвестная ошибка'}`,
          })
        }
        this.showChatLoadingStatus = false;
      },
      getChatClassList(chat) {
        return {
          active: chat.id === this.getActiveChatId,
          unread: chat.unread,
          closed: chat.closed,
          admin: chat.username === 'admin',
        }
      },
      handleFilter(filter) {
        this.filters[filter] = !this.filters[filter];
      },
    }
  }
</script>
<style>
  .chats__module {
    height: 100%;
  }

  .chats__container {
    height: 100%;
    display: flex;
  }

  .chats-list__main {
    width: 25%;
    min-width: 300px;
    display: flex;
    flex-direction: column;
  }

  .chats__title {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-weight: bold;
    background: #676767;
    color: white;
    padding: 10px;
    border-left: 1px solid white;
    text-shadow: 1px 1px 2px #222222;
    height: 18px;
  }

  .chats-list__block {
    height: calc(100% - 40px);
    overflow-y: scroll;
  }

  .chats-dialog__container {
    background-color: #f5fff5;
    padding: 10px 5px;
    border: 1px solid #cccccc;
    cursor: pointer;
    position: relative;
  }

  .chats-dialog__container.active {
    border: 2px solid #2ea92e;
    box-shadow: 1px 1px #0c6b0f;
  }

  .chats-dialog__container.unread {
    background-color: #efe0c7;
  }

  .chats-dialog__container.closed {
    background-color: #a3a3a3;
  }

  .chats-dialog__container.admin {
    background-color: #fa6767;
  }

  .chats-legend__container {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 5px;
  }

  .legend__block {
    display: flex;
    align-items: center;
    padding: 2px;
    margin: 0 2px;
    cursor: pointer;
  }

  .legend-color {
    width: 16px;
    height: 16px;
    margin-right: 5px;
    border: 1px solid black;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
  }

  .legend-color.opened {
    background-color: #f5fff5;
  }

  .legend-color.unread {
    background-color: #efe0c7;
  }

  .legend-color.closed {
    background-color: #a3a3a3;
  }

  .legend-color.admin {
    background-color: #fa6767;
  }

  .chat-dialog__info {
    display: flex;
    height: 100%;
  }

  .chats-dialog__title {
    font-weight: bold;
    margin-right: 5px;
  }

  .chats-dialog__value {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    line-height: 1.3em;
  }

  .chat-dialog__members {
    display: flex;
  }

  .chat-dialog__member {
    color: #656363;
    margin-right: 5px;
    font-size: 12px;
  }

  .chat-dialog__time {
    font-size: 12px;
  }

  .chat-dialog__notification {
    position: absolute;
    right: 0;
    bottom: 0;
    font-size: 14px;
    color: #ff7600;
  }

  .change-value__container {
    display: flex;
    margin-bottom: 10px;
  }

  .change-value__container .title {
    width: 250px;
    align-self: center;
  }

  .change-value__container .value {
    width: 250px;
    align-self: center;
  }

  .chats-search__container {
    padding: 8px;
    border: 1px solid #e4e4e4;
  }

  .chats-search__title {
    margin-bottom: 5px;
    text-align: center;
    font-weight: 500;
  }

  .chats-search-mode__container {
    padding: 5px;
    text-align: center;
  }

  .search-input__container {
    display: flex;
  }

  .search-reset__button {
    margin: auto 5px !important;
  }

  .chat-notices__container {
    position: absolute;
    display: flex;
    right: 3px;
    top: 1px;
  }

  .chat-claim__notice {
    color: #F56C6C;
  }

  .chat-problem__notice {
    color: #E6A23C;
  }

  .chat-lottery__notice {
    color: #ff1616;
  }
</style>
